import axios from 'axios';

import { allocationConstants, businessConstants } from '../constants';
import { businessActions } from './businessActions';
import { clearAssemblyForBusinessCase, clearAll } from '../slices/assemblySlice';

export const allocationActions = {
    getAllocations,
    createAllocation,
    updateAllocation,
    deleteAllocation,
    copyAllocations,
};
function mapAllocation(dto) {
    const toStr    = (v) => (v == null ? '' : String(v));
    const toStrArr = (a) => (Array.isArray(a) ? a.map(toStr) : []);

    const allocation_id = dto.allocation_id ?? dto.id ?? dto.key;

    return {
    allocation_id,        
    key: allocation_id,                  

    businessCaseId:   dto.business_case_id,  // number | null
    entityId:         dto.entity_id,         // number | null
    scenarioId:       Array.isArray(dto.scenario_id) ? dto.scenario_id : [], // number[]
    accountId:        dto.account_id,        // number | null
    targetEntityId:   dto.target_entity_id,  // number | null
    targetScenarioId: Array.isArray(dto.target_scenario_id) ? dto.target_scenario_id : [], // number[]
    targetAccountId:  dto.target_account_id, // number | null
  };
}

function getAllocations() {
    return async (dispatch) => {
        dispatch(request());

        try {
            const response = await axios.get('/allocations');
           // console.log('RAW dto sample:', response.data?.[0]);

           const allocations = (response.data || []).map(mapAllocation);
           
            if (response.status === 200) dispatch(success(allocations));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to allocations at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: allocationConstants.GET_ALLOCATION_REQUEST };
    }
    function success(allocations) {
        return {
            type: allocationConstants.GET_ALLOCATION_SUCCESS,
            allocations,
        };
    }
    function failure(error) {
        return { type: allocationConstants.GET_ALLOCATION_FAILURE, error };
    }
}

function createAllocation(payload) {
    return async (dispatch) => {
        dispatch({ type: allocationConstants.CREATE_ALLOCATION_REQUEST });

        try {
            const response = await axios.post('/allocations', payload);

            const newAllocation = mapAllocation(response.data);
                dispatch({ type: allocationConstants.CREATE_ALLOCATION_SUCCESS, allocation: newAllocation });
                dispatch(businessActions.clearAssembledBusinessCase(newAllocation.businessCaseId));
                dispatch(clearAssemblyForBusinessCase(newAllocation.businessCaseId));
                } catch (error) {
                    dispatch({ type: allocationConstants.CREATE_ALLOCATION_FAILURE,
                        error: error.response ? String(error.response.data) : 'Unable to create allocation...' });
                    }
                };
            }

        function copyAllocations(payloads) {
            return async (dispatch) => {
                const total = payloads.length;
                dispatch({ type: allocationConstants.COPY_ALLOCATIONS_REQUEST, payload: { total } });

                const created = [];
                const failed = [];

                for (let index = 0; index < total; index += 1) {
                    const payload = payloads[index];
                    try {
                        const response = await axios.post('/allocations', payload);
                        const allocation = mapAllocation(response.data);
                        created.push(allocation);
                        dispatch({ type: allocationConstants.CREATE_ALLOCATION_SUCCESS, allocation });
                    } catch (error) {
                        failed.push({
                            payload,
                            error: error.response ? String(error.response.data) : 'Unable to create allocation...',
                        });
                    }
                    dispatch({
                        type: allocationConstants.COPY_ALLOCATIONS_PROGRESS,
                        payload: { completed: index + 1, total },
                    });
                }

               if (created.length > 0) {
                    dispatch(businessActions.clearAssembledBusinessCase(created[0].businessCaseId));
                    dispatch(clearAssemblyForBusinessCase(created[0].businessCaseId));
                }

                dispatch({
                    type: allocationConstants.COPY_ALLOCATIONS_SUCCESS,
                    payload: { created: created.length, failed: failed.length },
                });

                return { created: created.length, failed };
            };
        }

function updateAllocation(id, payload) {
  return async (dispatch) => {
    dispatch({ type: allocationConstants.UPDATE_ALLOCATION_REQUEST, payload: { id } });
     try {
      const response = await axios.put(`/allocations/${id}`, payload);
      const updated = mapAllocation(response.data);

      dispatch({ type: allocationConstants.UPDATE_ALLOCATION_SUCCESS, allocation: updated });
        dispatch(businessActions.clearAssembledBusinessCase(updated.businessCaseId));
        dispatch(clearAssemblyForBusinessCase(updated.businessCaseId));

    } catch (error) {
      dispatch({ type: allocationConstants.UPDATE_ALLOCATION_FAILURE,
        error: error.response ? String(error.response.data) : 'Unable to update allocation...' });
    }
  };
}

function deleteAllocation(allocationId) {
  return async (dispatch, getState) => {
    // Read before deleting — the reducer removes it from state on success.
    const existing = (getState().allocations.allocations ?? []).find(
      (a) => Number(a.allocation_id) === Number(allocationId)
    );
    const businessCaseId = existing?.businessCaseId;

    dispatch({ type: allocationConstants.DELETE_ALLOCATION_REQUEST, payload: { id: allocationId } });

    try {
      await axios.delete(`/allocations/${allocationId}`);
      // Always dispatch the id we deleted; ignore response body shape
      dispatch({ type: allocationConstants.DELETE_ALLOCATION_SUCCESS, payload: { id: allocationId } });

      if (businessCaseId != null) {
            dispatch(businessActions.clearAssembledBusinessCase(businessCaseId));
            dispatch(clearAssemblyForBusinessCase(businessCaseId));
            } else {
            dispatch(businessActions.clearAssembledBusinessCases());
            dispatch(clearAll());
            }
    } catch (error) {
      dispatch({
        type: allocationConstants.DELETE_ALLOCATION_FAILURE,
        error: error.response ? String(error.response.data) : 'Unable to delete allocation at this moment. Please try again later.',
      });
    }
  };
}
